import React from "react";
import { Modal, ModalBody, } from "reactstrap";
import bin from "../../assets/images/bin.gif"

function DeleteModal({ showModal, setShowModal, handleDelete }) {
  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <Modal
         isOpen={showModal}
         toggle={handleCloseModal}
         centered
      >
          <ModalBody className="d-flex flex-column justify-content-center align-items-center" >
            <img src={bin} alt="" style={{height:"80px"}} />
        <h6 className="mt-5 mb-5">Are you sure to delete?</h6>
        <div className="d-flex">
        <button 
        className="btn btn-outline-primary-600 wd-100 radius-8 px-14 py-6 text-md"  onClick={handleCloseModal}>
          Cancel
        </button>
        <button className="btn btn-primary-600 wd-100 radius-8 px-14 py-6 text-md ms-3" onClick={handleDelete}>
          Delete
        </button>
        </div>
      </ModalBody>
      </Modal>
    </>
  );
}

export default DeleteModal;